import isEmail from 'validator/lib/isEmail';

// Uses the "Extended_Pictographic" Unicode character class to indentify emojis.
// Related SO post: https://stackoverflow.com/questions/18862256/how-to-detect-emoji-using-javascript
export const hasEmoji = (input: string) => input.match(/\p{Extended_Pictographic}/u);

// Don't support non-ascii characters (those that have been converted to "xn--")
export default (input: string) => isEmail(input) && !hasEmoji(input) && !/@xn--/.test(input);
